module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Berreta686_C.66bb3071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Berreta686_C.png
// module id = 213
// module chunks = 0